export const STALE_BUILD_PROMPT_FEATURE_FLAG = 'seccl-38362-refresh-prompt';

const failedDataRequestMessage = 'Failed to load static props';

export const isFailedDataNavigation = (
  error: { message?: string } | null | undefined,
  targetUrl: string,
  currentUrl: string
): boolean => targetUrl === currentUrl && error?.message?.startsWith(failedDataRequestMessage) === true;

export const isDifferentBuildLive = (serverVersion: string | undefined, clientVersion: string): boolean =>
  typeof serverVersion === 'string' && serverVersion !== '' && serverVersion !== clientVersion;
